module.exports = __webpack_public_path__ + "img/e-matrix.b42e84c0.png";